// export const BUSINESS_FACEBOOK_APP_ID = '2014978988747519'; //'773415596501686';

export const USER_NAME_REGEX = /^[a-zA-Z0-9._-]+$/;

export const EmojiTranslations = {
  search: 'Поиск',
  clear: 'Очистить', // Accessible label on "clear" button
  notfound: 'Ничего не найдено',
  skintext: 'Выберите стандартный цвет кожи',
  categories: {
    search: 'Результаты поиска',
    recent: 'Часто используемые',
    smileys: 'Смайлы и эмоции',
    people: 'Люди и тело',
    nature: 'Животные и природа',
    foods: 'Еда и напитки',
    activity: 'Активности',
    places: 'Путешествия и места',
    objects: 'Обьекты',
    symbols: 'Символы',
    flags: 'Флаги',
    custom: 'Дополнительно',
  },
  categorieslabel: 'Категории', // Accessible title for the list of categories
  skintones: {
    1: 'Default Skin Tone',
    2: 'Light Skin Tone',
    3: 'Medium-Light Skin Tone',
    4: 'Medium Skin Tone',
    5: 'Medium-Dark Skin Tone',
    6: 'Dark Skin Tone',
  },
};

export const CAMPAIGNS_PER_PAGE = 15;

// export const PAYMENT_PLAN_PRO_PRICE = 10;

// export const EMAIL_CAMPAIGN_STORAGE_KEY = 'unisender_email_campaign';

// export const PAYMENTWALL_BRICK_PUBLIC_KEY = 't_9b107f28501dfec0beb415bf97ccc4';

// export const LINKEDIN_APP_ID = '78tdn1ubybxvwt';

// export const TIME_ZONE_INFO =
//   'Данный часовой пояс используется для отложенного постинга в Twitter. Социальные сети Vkontakte и Facabook используют часовой пояс, который установлен на странице в социальной сети.';
